// extracted by mini-css-extract-plugin
export default {"note-group":"NoteGroup_note-group__4qBOZ","selected":"NoteGroup_selected__raDNs","group-name":"NoteGroup_group-name__NbTST","group-initials":"NoteGroup_group-initials__rD4K8"};